import React, { Component } from "react";
import { PostData } from "../../../service/postData";
import { sendNotification } from "../../../_notificationSettings/notificationPanel";
import { MDBDataTableV5 } from "mdbreact";
import { numberFormat } from "../../../config/numberFormat";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Link } from "react-router-dom";
import moment from "moment";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";

import "./loanstatment.css";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import DownloadBtnLoanStatementPdf from "../Invoices/LoanStatement/DownloadBtnLoanStatementPdf";
import PrintBtnLoanStatementPdf from "../Invoices/LoanStatement/PrintBtnLoanStatementPdf";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Loader } from "@progress/kendo-react-indicators";

let _UserSession = localStorage.getItem("vs_UserSession");
let _signingId = "0";
let _businessId = "0";
let _companyId = "0";

if (_UserSession != undefined || _UserSession != null) {
  _UserSession = JSON.parse(_UserSession);
  _signingId = _UserSession.loginId;
  _businessId = _UserSession.tokenKey;
}

let _companySession = localStorage.getItem("vs_UserCompanySession");
if (_companySession != undefined || _companySession != null) {
  _companySession = JSON.parse(_companySession);
  _businessId = _companySession.business_id;
  _companyId = _companySession.company_id;
}

let columns = [
  {
    label: "#",
    field: "srNo",
    width: 20,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "#",
    },
  },
  {
    label: "Date",
    field: "invoice_date",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Date",
    },
  },
  {
    label: "Txn Type",
    field: "txn_type",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Txn Type",
    },
  },
  {
    label: "Amount",
    field: "amount",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Amount",
    },
  },
  {
    label: "Ending Bal",
    field: "end_bal",
    width: 150,
    attributes: {
      "aria-controls": "DataTable",
      "aria-label": "Ending Bal",
    },
  },
];

let _loader = "glb-ldr-prt active";

export default class userSaleListPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonTitle: "Add Sale",
      isLoaded: true,
      transactionArray: [],
      transactionArrayFilter: [],
      businessId: _businessId,
      company_id: _companyId,
      userId: _signingId,
      name: null,
      opening_balance: "",
      isPdfLoading: false,
      loanAccountArray: [],
      paidAmount: 0,
      unpaidAmount: 0,
      total: 0,
      loanId: 0,

      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      dateLabel: "",
      errors: {
        name: "",
      },
    };
  }

  async componentDidMount() {
    let _handleParam = this.props.location.search;
    _handleParam = _handleParam.split("?auth=");
    let loanId = _handleParam[1] ? _handleParam[1] : 0;

    this.getSaleListData();
    this.getLoanAccListData();

    this.setState({ loanId: loanId });
  }

  getLoanAccListData() {
    let _loanAccountArray = [];

    let _handleParam = this.props.location.search;
    _handleParam = _handleParam.split("?auth=");
    let loanId = _handleParam[1] ? _handleParam[1] : 0;

    let _url_GetData =
      global.userLoanAccountList + "?company_id=" + this.state.company_id;
    PostData(_url_GetData, "", "GET")
      .then((result) => {
        let responseJson = result;
        console.log("responseJson", JSON.stringify(responseJson));
        if (responseJson.success == false) {
          this.setState({ isLoaded: true });
        } else {
          if (responseJson.response) {
            _loanAccountArray = responseJson.response;
          }
          this.setState({
            loanAccountArray: _loanAccountArray,
            isLoaded: true,
            loanId: loanId,
          });
        }
      })
      .catch((error) => this.setState({ error, isLoaded: false }));
  }

  getSaleListData() {
    let _transArray = [];
    let _opening_balance = 0;
    let _accountName = "";
    let _balanceDue = 0;
    let _totalPrincipal = 0;
    let _totalInterest = 0;
    let _handleParam = this.props.location.search;
    _handleParam = _handleParam.split("?auth=");
    let loanId = _handleParam[1] ? _handleParam[1] : 0;

    const requestData = JSON.stringify({
      loan_id: loanId,
      isDateFilter: true,
      start_date: this.state.startDate,
      end_date: this.state.endDate,
    });

    PostData(global.userIncreaseLoanStatementList, requestData, "POST")
      .then((result) => {
        let responseJson = result;

        if (responseJson.success == false) {
          this.setState({
            transactionArrayFilter: _transArray,
            itemArray: _transArray,
            isLoaded: true,
            opening_balance: _opening_balance,
            accountName: _accountName,
            balanceDue: _balanceDue,
            totalPrincipal: _totalPrincipal,
            totalInterest: _totalInterest,
          });
        } else {
          if (responseJson.response) {
            _transArray = responseJson.response;
            _accountName = responseJson.accountName;
            _balanceDue = parseFloat(responseJson.balanceDue);
            _totalPrincipal = parseFloat(responseJson.totalPrincipal);
            _totalInterest = parseFloat(responseJson.totalInterest);
            _opening_balance = parseFloat(responseJson.opening_balance);
          }
          this.setState({
            transactionArrayFilter: _transArray,
            itemArray: _transArray,
            isLoaded: true,
            opening_balance: _opening_balance,
            accountName: _accountName,
            balanceDue: _balanceDue,
            totalPrincipal: _totalPrincipal,
            totalInterest: _totalInterest,
          });
        }
      })
      .catch((error) => this.setState({ error, isLoaded: false }));
  }

  async exportPdf() {
    let _transDetails = this.state.transactionArrayFilter;
    if (_transDetails.length > 0) {
      //printArea.style.display = 'none';
    }
  }

  loadTranscListing() {
    let dataList = [];
    let rows = [];
    if (this.state.isLoaded == true) {
      let _transDetails = this.state.transactionArrayFilter;
      if (_transDetails.length > 0) {
        let _i = 0;
        _transDetails.map((value, index) => {
          _i++;
          rows.push({
            srNo: _i, //value.srNo,
            invoice_date: value.added_on,
            txn_type: value.type,
            amount: numberFormat(value.amount),
            end_bal: numberFormat(value.end_balance),
          });
        });
      }
    }

    if (rows) {
      dataList = {
        columns: columns,
        rows: rows,
      };
    }
    return dataList;
  }

  handleCallBackDate = (start, end) => {
    this.setState({
      startDate: start.format("YYYY-MM-DD"),
      endDate: end.format("YYYY-MM-DD"),
    });
    this.getSaleListData();
  };

  loanAccChange(e) {
    window.location.href =
      global.webUrl + "business/manage-loan-statement/?auth=" + e.target.value;
  }

  render() {
    if (this.state.isLoaded == true) {
      _loader = "glb-ldr-prt";
    }
    const { errors } = this.state;
    return (
      <React.Fragment>
        <div className="content">
          <div className="content-header">
            <div className="header-section">
              <h1 className="content-heading">
                <i className="gi gi-direction"></i>Loan Statement
                <br />
              </h1>
            </div>
          </div>
          <nav className="breadcrumb push">
            <a
              className="breadcrumb-item"
              href={global.webUrl + "business/dashboard/"}
            >
              Dashboard
            </a>
            <a
              className="breadcrumb-item"
              href={global.webUrl + "business/manage-loan-accounts/"}
            >
              Loan Account List
            </a>
            <span className="breadcrumb-item active">Loan Statement </span>
          </nav>

          <div className="block">
            <div className="row">
              <div className="col-md-12">
                <div className="block">
                  <div className="block-content">
                    <div className="row items-push">
                      <div className="row col-lg-12">
                        <div className="col-lg-8">
                          <span>Filter : </span>
                          <DateRangePicker
                            initialSettings={{
                              startDate: this.state.startDate,
                              endDate: this.state.endDate,
                              locale: {
                                format: "YYYY-MM-DD",
                              },
                              ranges: {
                                Today: [moment().toDate(), moment().toDate()],
                                Yesterday: [
                                  moment().subtract(1, "days").toDate(),
                                  moment().subtract(1, "days").toDate(),
                                ],
                                "Last 7 Days": [
                                  moment().subtract(6, "days").toDate(),
                                  moment().toDate(),
                                ],
                                "Last 30 Days": [
                                  moment().subtract(29, "days").toDate(),
                                  moment().toDate(),
                                ],
                                "This Month": [
                                  moment().startOf("month").toDate(),
                                  moment().endOf("month").toDate(),
                                ],
                                "Last Month": [
                                  moment()
                                    .subtract(1, "month")
                                    .startOf("month")
                                    .toDate(),
                                  moment()
                                    .subtract(1, "month")
                                    .endOf("month")
                                    .toDate(),
                                ],
                              },
                            }}
                            onCallback={this.handleCallBackDate}
                          >
                            <input
                              type="text"
                              className="form-control col-6"
                              style={{ display: "inline-block" }}
                            />
                          </DateRangePicker>
                        </div>

                        <div className="col-lg-4">
                          <span>Select Account : </span>
                          <select
                            className="form-control"
                            style={{ width: "215px", display: "inline-block" }}
                            id="loanAccount"
                            name="loanAccount"
                            required="required"
                            onChange={this.loanAccChange}
                          >
                            {this.state.loanAccountArray.map(
                              (loanAcc, index) => {
                                let _sel = "";
                                if (this.state.loanId == loanAcc.loan_id) {
                                  _sel = "selected";
                                }
                                return (
                                  <option
                                    key={index}
                                    value={loanAcc.loan_id}
                                    selected={_sel}
                                  >
                                    {loanAcc.account_name}
                                  </option>
                                );
                              }
                            )}
                          </select>
                        </div>
                        <br />
                      </div>
                      <div className="col-lg-12">
                        <p className="mb-10" style={{ fontSize: "15px" }}>
                          <b>Loan Accounts : {this.state.accountName} </b>
                          <br />
                          Opening Balance :{" "}
                          {numberFormat(this.state.opening_balance)}
                          <br />
                          Balance Due : {numberFormat(this.state.balanceDue)}
                          <br />
                          Total Principal Paid :{" "}
                          {numberFormat(this.state.totalPrincipal)}
                          <br />
                          Total Interest Paid :{" "}
                          {numberFormat(this.state.totalInterest)}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="block">
            <div className="row">
              <div className="col-md-12">
                <div className="block">
                  <div className="block-content row">
                    <h2
                      className="block-title ml-10"
                      style={{ display: "inline-block" }}
                    >
                      Transactions
                    </h2>
                    {this.state.transactionArrayFilter.length > 0 && (
                      <>
                        <DownloadBtnLoanStatementPdf
                          startDate={this.state.startDate}
                          endDate={this.state.endDate}
                          auth={this.state.loanId}
                          loading={(isLoading) =>
                            this.setState({ isPdfLoading: isLoading })
                          }
                        />

                        <PrintBtnLoanStatementPdf
                          startDate={this.state.startDate}
                          endDate={this.state.endDate}
                          auth={this.state.loanId}
                          loading={(isLoading) =>
                            this.setState({ isPdfLoading: isLoading })
                          }
                        />
                      </>
                    )}
                  </div>
                  <div className="block-content" id="tableData">
                    <MDBDataTableV5
                      hover
                      entriesOptions={[25, 50, 100]}
                      entries={25}
                      pagesAmount={4}
                      span
                      pagingTop
                      searchTop
                      searchBottom={false}
                      barReverse
                      data={this.loadTranscListing()}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div id="global_loader" className={_loader}>
          <div className="gl-ldr-cld">
            <div className="gl-ldr-ctr">
              <div className="gl-loader"></div>
            </div>
          </div>
        </div>

        {this.state.isPdfLoading && (
          <Dialog>
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(255, 255, 255, 0.4)", // Light transparent background
                backdropFilter: "blur(8px)", // Blur effect
                WebkitBackdropFilter: "blur(8px)", // Safari support
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999, // ensure it's on top
                textAlign: "center",
              }}
            >
              <Loader type="pulsing" />
              <h5 style={{ marginTop: "50px" }}>Please Wait ...</h5>
            </div>
          </Dialog>
        )}
      </React.Fragment>
    );
  }
}
